// DsNum — implementa a numeração tabular do canvas (DESIGN-SYSTEM.md §3.3):
//   `font-variant-numeric:tabular-nums` inline em 139 dos 143 artboards -> <DsNum>
//   `.mono` em 24 artboards                                            -> <DsNum mono>
//   `.hex` em 11 artboards                                             -> <DsNum>
//
// É a peça mais barata por alcance do kit. Usos do canvas: CNPJ/CPF, competência,
// número de nota, protocolo, R$, contagem do `.pager`, percentual de legenda e todo
// `.kpi-total`.
//
// Dentro de grade, a célula já recebe `fontVariantNumeric` por `SX_GRADE_CANVAS` (§4.1) —
// lá o `DsNum` só é necessário quando se quer `mono`.
//
// O único lugar do app com isto hoje é a constante `MONO` de
// `src/modules/conta-fiscal/views/conta-fiscal-format.ts`; ela é promovida a primitiva
// aqui e aquele arquivo passa a reexportar deste módulo.

import type { SystemStyleObject } from '@mui/system';
import type { Theme, SxProps } from '@mui/material/styles';

import Box from '@mui/material/Box';

import { DS_MONO, DS_TABULAR } from './tokens';

// ----------------------------------------------------------------------

export type DsNumProps = {
  children: React.ReactNode;
  /** Família monoespaçada do canvas (`.mono`). Padrão: false. */
  mono?: boolean;
  /**
   * Padrão: 'left'. Com 'right' o span vira bloco de largura total para que a coluna
   * alinhe à direita — é como o canvas alinha valor de R$ e contagem.
   */
  align?: 'left' | 'right';
  sx?: SxProps<Theme>;
};

// ----------------------------------------------------------------------

const SX_MONO = { fontFamily: DS_MONO } satisfies SystemStyleObject<Theme>;

const SX_DIREITA = {
  textAlign: 'right',
  display: 'inline-block',
  width: '100%',
} satisfies SystemStyleObject<Theme>;

// ----------------------------------------------------------------------

export function DsNum({ children, mono = false, align = 'left', sx }: DsNumProps) {
  return (
    <Box
      component="span"
      sx={[
        DS_TABULAR,
        mono && SX_MONO,
        align === 'right' && SX_DIREITA,
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
}
